<template>
  <v-card elevation="5" outlined shaped>
    <div>
      <v-alert dense color="#EE680B" style="color: #ffffff">
        <h5>INFORMACIÓN PERSONAL</h5>
      </v-alert>
    </div>
    <div>
    <template>
  <v-simple-table>
    <template v-slot:default>
      <v-row>
          <v-col cols="4">
             <h5> UNICODIGO:</h5>
          </v-col>
          <v-col cols="8">
             <h5>{{ unicodigo }} </h5>
          </v-col>
          <v-col cols="4">
             <h5> ESTUDIANTE:</h5>
          </v-col>
          <v-col cols="8">
             <h5>{{ nomus }}</h5>
          </v-col>
           <v-col cols="4">
             <h5> DOCUMENTO:</h5>
          </v-col>
          <v-col cols="8">
             <h5>{{ num_documento }}</h5>
          </v-col>
            <v-col cols="4">
             <h5> TELEFONO:</h5>
          </v-col>
          <v-col cols="8">
             <h5>{{ telefono }}</h5>
          </v-col>
             <v-col cols="4">
             <h5> EMAIL:</h5>
          </v-col>
          <v-col cols="8">
             <h5>{{ email }} </h5>
          </v-col>
           <v-col cols="12">
             
          </v-col>

          

      </v-row>
     
      <!-- <tbody>
        <tr   
        >
          <td>{{ nombres }}</td>
          <td>{{ unicodigo }}</td>
        </tr>
      </tbody> -->
    </template>
  </v-simple-table>
</template>
    </div>
  </v-card>
</template>
  <script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
export default {
  data() {
    return {
      materno: "",
      paterno: "",
      nombres: "",
      fechaHoy: "",
      fechaEntrega: "",
      mat: "",
      pat: "",
      id_estudiante: "",
      unicodigo: "",
      num_documento: "",
      paterno: "",
      materno: "",
      nombreCompleto: "",
      datosCarrera: [],
      idPlanestudio: "",
      idCarrera: "",
      carrera: "",
      gestion: "",
      idGestion: "",
      datosOfertaMaterias: [],
      idMateria: "",
      detalleModal: 0,
      datosCantidadEstGrupo: [],
      datosGruposInscripcion: [],
      idTurno: "",
      datosTurno: [],
      turno: "",
      idGrupoDocente: "",
      idTipoModalidad: "",
      modalidad: "",
      paralelo: "",
      capacidad: "",
      tipoGrupo: "",
      idNivel: "",
      idUsuario: 6,
      idPlanEconomico: "",
      yaInscrito: false,
      cantidadMaximaMaterias: 7,
      datosGruposPreInscripcion: [],
      idNota: "",
      minimoNivel: "",
      datosOfertaMateriasNivel: [],
      datosEstudiante: [],
      nombresBene: "",
      paternoBene: "",
      maternoBene: "",
      numDocBene: "",
      idPais: "",
      pais: "",

      //tipo: "PRACTICO",
      gruposPracticosModal: 0,
      maxMateriasPreinscritas: 0,
      horarioModal: 0,
      datosHorario: [],
      idFranjaHoraria: "",
      idDia: "",
      cantAct: "",
      datosCantidadEspacio: [],
      datosHorariosGrupo: [],
      datosFranjaHoraria: [],
      //datosHorarioConvertido: [LUNES, MARTES, MIERCOLES, JUEVES, VIERNES, SABADO, DOMINGO],
      tienePractico: "FALSE",
      cantidadActualMaterias: 0,
      choqueHorario: 0,
      idGrupoPadre: "",
      esCompartido: "",
      kardexModal: 0,
      datosDocumentos: [],
      choquecant: 0,
      search: "",
      inpNum: "",
      id_docente: "",
      tipodocente: "",
      searchDocente: "",
      selectGenero: "",
      datosGenero: ["FEMENINO", "MASCULINO"],
      auxmat: "",
      auxpat: "",
      uniest: "",

      datosEstudiante: [],
      datosGestion: [],
      datosPais: [],

      est: "",
      elModal: 0,
      carreraModal: 0,
      gestionModal: 0,
      turnoModal: 0,
      horarioModal1: 0,
      documentosModal: 0,
      paisModal: 0,

      snackbarOK: false,
      mensajeSnackbar: "REGISTRO FALLIDO",
      mensajeSnackbarGrupoLleno: "GRUPO LLENO",
      mensajeSnackbarNivel: "AÚN TIENE MATERIAS DE NIVEL INFERIOR",
      mensajeSnackbarHorario: "CHOQUE DE HORARIO",
      mensajeSnackbarCantidadMaximaMaterias:
        "CANTIDAD MAXIMA DE MATERIAS TOMADAS",
      snackbarError: false,
      snackbarError1: false,
      snackbarError2: false,
      snackbarError3: false,
      mensajeError: "",

      timeout: 2000,

      alert: { show: false, message: "" },
      alertdocumento: { show: false, message: "" },

      headerspais: [
        { text: "PAIS", value: "pais", sortable: false },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersTurno: [
        { text: "TURNO", value: "turno", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersHorario: [
        { text: "HORA", value: "hr", sortable: true },
        { text: "LUNES", value: "docaumat", sortable: true },
        { text: "MARTES", value: "docaumat", sortable: true },
        { text: "MIERCOLES", value: "docaumat", sortable: true },
        { text: "JUEVES", value: "docaumat", sortable: true },
        { text: "VIERNES", value: "docaumat", sortable: true },
        { text: "SABADO", value: "docaumat", sortable: true },
        // { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersDocumentos: [
        { text: "DOCUMENTO", value: "documento", sortable: true },
        { text: "FECHA", value: "fpl", sortable: true },
        { text: "ESTADO", value: "estado", sortable: true },
        // { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersFranjaHoraria: [
        { text: "HORA", value: "hr", sortable: true },
        { text: "LUNES", value: "lu", sortable: true },
        { text: "MARTES", value: "ma", sortable: true },
        { text: "MIERCOLES", value: "mi", sortable: true },
        { text: "JUEVES", value: "ju", sortable: true },
        { text: "VIERNES", value: "vi", sortable: true },
        { text: "SABADO", value: "sa", sortable: true },
        { text: "DOMINGO", value: "do", sortable: true },
      ],
      headersCarrera: [
        { text: "CARRERA", value: "carre", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersCantidadEstGrupo: [
        { text: "GRUPO", value: "idgru", sortable: true },
        { text: "PATERNO", value: "pat", sortable: true },
        { text: "MATERNO", value: "mat", sortable: true },
        { text: "NOMBRE", value: "nomb", sortable: true },
        { text: "ESTUDIANTES INSCRITOS", value: "cant", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersGrupoInscripcion: [
        { text: "GRUPO", value: "gru", sortable: true },
        { text: "DOCENTE", value: "doce", sortable: true },
        { text: "NIVEL", value: "nivel", sortable: true },
        { text: "CUPO", value: "cup", sortable: true },
        { text: "MODALIDAD", value: "modalidad", sortable: true },
        { text: "TURNO", value: "tu", sortable: true },
        { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
        //{ text: "ESTADO", value: "est", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersGrupoInscripcionPracticos: [
        { text: "GRUPO", value: "gru", sortable: true },
        { text: "DOCENTE", value: "doce", sortable: true },
        { text: "NIVEL", value: "nivel", sortable: true },
        { text: "CUPO", value: "cup", sortable: true },
        { text: "MODALIDAD", value: "modalidad", sortable: true },
        { text: "TURNO", value: "tu", sortable: true },
        { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
        //{ text: "ESTADO", value: "est", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersGrupoPreInscripcion: [
        { text: "PARALELO", value: "gru", sortable: true },
        { text: "MATERIA", value: "mate", sortable: true },
        { text: "DOCENTE", value: "doce", sortable: true },
        { text: "NIVEL", value: "nivel", sortable: true },
        //{ text: "CUPO", value: "cup", sortable: true },
        { text: "MODALIDAD", value: "modalidad", sortable: true },
        { text: "TURNO", value: "tu", sortable: true },
        { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
        //{ text: "ESTADO", value: "est", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersOfertaMaterias: [
        { text: "NIVEL", value: "idni", sortable: true },
        //{ text: "IDMATERIA", value: "idmat", sortable: true },
        { text: "CODIGO MATERIA", value: "codmat", sortable: true },
        { text: "MATERIA", value: "mat", sortable: true },
        //{ text: "CANT MAX", value: "cantmax", sortable: true },
        //{ text: "ESTADO", value: "est", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersGestion: [
        { text: "GESTION", value: "nom", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersEstudiante: [
        { text: "UNICODIGO", value: "unicod", sortable: true },

        { text: "PATERNO", value: "pat", sortable: false },
        { text: "MATERNO", value: "mat", sortable: false },
        { text: "NOMBRES", value: "nom", sortable: false },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersKardex: [
        { text: "GESTION", value: "gest", sortable: true },
        { text: "MATERIA", value: "mate", sortable: true },
        { text: "1° P", value: "p1", sortable: true },
        { text: "2° P", value: "p2", sortable: false },
        { text: "3° P", value: "p3", sortable: true },
        { text: "EXM FINAL", value: "exfin", sortable: false },
        { text: "ASIST", value: "asis", sortable: true },
        { text: "2° INST", value: "seginst", sortable: true },
        { text: "MESA", value: "mesa", sortable: false },
        { text: "GRACIA", value: "graci", sortable: true },
        { text: "NOTA FINAL", value: "notafin", sortable: true },
        { text: "ESTADO", value: "estado", sortable: false },
        { text: "OBSERVACIONES", value: "observac", sortable: true },
      ],

      user: {},
      usuario: "",
      id_sede: "",
      nomus: "",
      patus: "",
      matus: "",
      id_documento: "",
      datosTipoDocumento: "",

      id_tipo_documento: "",
      tipo_doc_nom: "",
      iddocseg2: "",
      documento2: "",
      nivelMinimo: "",

      select: "",
      selectAño: "",
      selectCiudad: "",
      selectPais: "",
      tituloObtenido: "",
      institucion: "",
      areaEstudios: null,
      añoObtencion: "",
      cargaHoraria: null,
      datosPais: [],
      datosCiudad: [],
      tpFormacion: "",
      datosFormacionAcademica: [],
      selectPais1: "",
      act: 0,
      idForm: "",
      botonAct: 0,

      flag: 1,
    };
  },
  created: function () {
    this.user = JSON.parse(sessionStorage.getItem("session"));
    this.usuario = this.user.personal;
    this.id_sede = this.user.id_sede;
    this.nomus =
      this.user.nombres + " " + this.user.paterno + " " + this.user.materno;
    this.nombres = this.user.nombres;
    this.paterno = this.user.paterno;
    this.materno = this.user.materno;
    this.unicodigo = this.user.unico;
    this.listarDatosEstudiante(this.unicodigo, this.id_sede);
  },
  computed: {},
  components: {
    VueHtml2pdf,
  },

  methods: {
    llenarDatos() {
      this.num_documento = this.datosEstudiante[0].numdoc;
      this.fechaNaci = this.datosEstudiante[0].fhnac;
      this.email = this.datosEstudiante[0].mail;
      this.telefono = this.datosEstudiante[0].tel;
      this.nacionalidad = this.datosEstudiante[0].tpnac;
      this.direccionDocente = this.datosEstudiante[0].dir;
      this.nombresBene = this.datosEstudiante[0].nombene;
      this.paternoBene = this.datosEstudiante[0].patbene;
      this.maternoBene = this.datosEstudiante[0].matbene;
      this.selectGenero = this.datosEstudiante[0].sex;
      this.numDocBene = this.datosEstudiante[0].numdocbene;
      this.idPais = this.datosEstudiante[0].idpai;
      this.pais = this.datosEstudiante[0].pais;
    },

    async listarDatosEstudiante(unicodigo, id_sede) {
      let me = this;
      await axios
        .get(
          "/estudiante/listarDatosEst/" + this.unicodigo + "," + this.id_sede
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosEstudiante = [];
          } else {
            me.datosEstudiante = response.data.resultado;
            me.llenarDatos();
          }
        })
        .catch(function (error) {});
    },
  },
};
</script>
    
    